import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import { Appearance } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { useTheme } from 'styled-components';
const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY as string);
export const WrapWithStripeElement: React.FC<{
  loading: JSX.Element;
  children: (props: {
    elements: any;
    confirmCardSetup: () => Promise<string>;
  }) => React.ReactNode;
}> = t0 => {
  const $ = _c(77);
  const {
    loading,
    children
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const theme = useTheme();
  const t1 = theme.font_size;
  let t2;
  if ($[0] !== theme) {
    t2 = theme.pxToRem(theme.font_sizes.m.font_size);
    $[0] = theme;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== theme) {
    t3 = theme.pxToRem(theme.font_sizes.m.line_height);
    $[2] = theme;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = theme.colors.on.neutral.primary;
  const t5 = theme.colors.on.neutral.primary_neutral;
  const t6 = theme.colors.on.neutral.secondary_neutral;
  const t7 = theme.colors.on.neutral.danger;
  const t8 = theme.colors.surface.base.surface;
  const t9 = theme.radius.normal;
  let t10;
  if ($[4] !== theme) {
    t10 = theme.spacing(1);
    $[4] = theme;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  let t11;
  if ($[6] !== theme) {
    t11 = theme.spacing(3);
    $[6] = theme;
    $[7] = t11;
  } else {
    t11 = $[7];
  }
  let t12;
  if ($[8] !== theme) {
    t12 = theme.spacing(3);
    $[8] = theme;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== t10 || $[11] !== t11 || $[12] !== t12 || $[13] !== t2 || $[14] !== t3 || $[15] !== theme.colors.on.neutral.danger || $[16] !== theme.colors.on.neutral.primary || $[17] !== theme.colors.on.neutral.primary_neutral || $[18] !== theme.colors.on.neutral.secondary_neutral || $[19] !== theme.colors.surface.base.surface || $[20] !== theme.font_size || $[21] !== theme.radius.normal) {
    t13 = {
      fontFamily: "Inter,-apple-system,BlinkMacSystemFont,'avenir next',avenir,helvetica,'helvetica neue',ubuntu,roboto,noto,'segoe ui',arial,sans-serif",
      fontSizeBase: t1,
      fontSizeSm: t2,
      fontLineHeight: t3,
      colorPrimary: t4,
      colorText: t5,
      colorTextPlaceholder: t6,
      colorDanger: t7,
      colorBackground: t8,
      borderRadius: t9,
      spacingUnit: t10,
      spacingGridRow: t11,
      spacingGridColumn: t12
    };
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t2;
    $[14] = t3;
    $[15] = theme.colors.on.neutral.danger;
    $[16] = theme.colors.on.neutral.primary;
    $[17] = theme.colors.on.neutral.primary_neutral;
    $[18] = theme.colors.on.neutral.secondary_neutral;
    $[19] = theme.colors.surface.base.surface;
    $[20] = theme.font_size;
    $[21] = theme.radius.normal;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== theme) {
    t14 = theme.pxToRem(theme.font_sizes.xs.font_size);
    $[23] = theme;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== theme) {
    t15 = theme.pxToRem(theme.font_sizes.xs.line_height);
    $[25] = theme;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = theme.colors.on.neutral.tertiary_neutral;
  let t17;
  if ($[27] !== theme) {
    t17 = theme.spacing(1);
    $[27] = theme;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t14 || $[30] !== t15 || $[31] !== t17 || $[32] !== theme.colors.on.neutral.tertiary_neutral) {
    t18 = {
      fontSize: t14,
      lineHeight: t15,
      fontWeight: "500",
      color: t16,
      marginBottom: t17
    };
    $[29] = t14;
    $[30] = t15;
    $[31] = t17;
    $[32] = theme.colors.on.neutral.tertiary_neutral;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== theme) {
    t19 = theme.pxToRem(theme.font_sizes.m.font_size);
    $[34] = theme;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== theme) {
    t20 = theme.pxToRem(theme.font_sizes.m.line_height);
    $[36] = theme;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== theme) {
    t21 = theme.spacing(1.5);
    $[38] = theme;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== theme) {
    t22 = theme.spacing(3);
    $[40] = theme;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  const t23 = `${t21} ${t22}`;
  let t24;
  if ($[42] !== t19 || $[43] !== t20 || $[44] !== t23 || $[45] !== theme.colors.surface.base.surface || $[46] !== theme.shadows.input.neutral) {
    t24 = {
      fontSize: t19,
      lineHeight: t20,
      padding: t23,
      boxShadow: theme.shadows.input.neutral,
      border: "none",
      backgroundColor: theme.colors.surface.base.surface
    };
    $[42] = t19;
    $[43] = t20;
    $[44] = t23;
    $[45] = theme.colors.surface.base.surface;
    $[46] = theme.shadows.input.neutral;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== theme.shadows.input.focused) {
    t25 = {
      boxShadow: theme.shadows.input.focused,
      outline: "none"
    };
    $[48] = theme.shadows.input.focused;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== theme.colors.on.neutral.danger || $[51] !== theme.colors.surface.container.danger || $[52] !== theme.shadows.input.error) {
    t26 = {
      boxShadow: theme.shadows.input.error,
      backgroundColor: theme.colors.surface.container.danger,
      color: theme.colors.on.neutral.danger
    };
    $[50] = theme.colors.on.neutral.danger;
    $[51] = theme.colors.surface.container.danger;
    $[52] = theme.shadows.input.error;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== theme.colors.on.neutral.secondary_neutral) {
    t27 = {
      color: theme.colors.on.neutral.secondary_neutral
    };
    $[54] = theme.colors.on.neutral.secondary_neutral;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t18 || $[57] !== t24 || $[58] !== t25 || $[59] !== t26 || $[60] !== t27) {
    t28 = {
      ".Label": t18,
      ".Input": t24,
      ".Input:focus": t25,
      ".Input--invalid": t26,
      ".Input::placeholder": t27
    };
    $[56] = t18;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t13 || $[63] !== t28) {
    t29 = {
      theme: "none",
      variables: t13,
      rules: t28
    };
    $[62] = t13;
    $[63] = t28;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  const appearance = t29;
  let t30;
  if ($[65] !== HookdeckAPI) {
    t30 = async (stripe, elements) => {
      const {
        error: submit_error
      } = await elements.submit();
      if (submit_error) {
        throw submit_error;
      }
      const {
        client_secret
      } = await HookdeckAPI.billing.getToken();
      const {
        error,
        setupIntent
      } = await stripe.confirmSetup({
        elements,
        clientSecret: client_secret,
        redirect: "if_required"
      });
      if (error != null || setupIntent?.status !== "succeeded") {
        throw error ?? new Error("Payment method could not be saved succesfully.");
      }
      return setupIntent.payment_method;
    };
    $[65] = HookdeckAPI;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  const confirmCardSetup = t30;
  let t31;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = ["card"];
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== appearance) {
    t32 = {
      mode: "setup",
      paymentMethodTypes: t31,
      appearance
    };
    $[68] = appearance;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== children || $[71] !== confirmCardSetup || $[72] !== loading) {
    t33 = <ElementsConsumer>{t34 => {
        const {
          stripe: stripe_0,
          elements: elements_0
        } = t34;
        return stripe_0 && elements_0 ? children({
          elements: elements_0,
          confirmCardSetup: () => confirmCardSetup(stripe_0, elements_0)
        }) : loading;
      }}</ElementsConsumer>;
    $[70] = children;
    $[71] = confirmCardSetup;
    $[72] = loading;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t32 || $[75] !== t33) {
    t34 = <Elements stripe={stripePromise} options={t32}>{t33}</Elements>;
    $[74] = t32;
    $[75] = t33;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  return t34;
};
export default WrapWithStripeElement;